import {useAnalytics} from '@github-ui/use-analytics'
import {Button} from '@primer/react'

import type {CommentingImplementation, SuggestedChange} from '../../types'

export function AddToExistingBatch({
  commentingImplementation,
  suggestedChange,
}: {
  suggestedChange: SuggestedChange
  commentingImplementation: CommentingImplementation
}) {
  const {sendAnalyticsEvent} = useAnalytics()
  return (
    <div className="d-flex flex-row-reverse">
      <Button
        variant="primary"
        onClick={() => {
          sendAnalyticsEvent('comments.add_suggested_change_to_batch', 'ADD_SUGGESTED_CHANGE_TO_BATCH_BUTTON', {
            commentKind: 'human',
            surface: 'commits',
          })
          commentingImplementation.addSuggestedChangeToPendingBatch(suggestedChange)
        }}
      >
        Add suggestion to batch
      </Button>
    </div>
  )
}
